import React from 'react';

import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';

import type { QpsNote } from '@/types/qps';

interface QpsNotesProps {
  notes: QpsNote[];
}

const QpsNotes: React.FC<QpsNotesProps> = ({ notes }) => {
  const { t } = useTranslation();

  if (notes.length === 0) return null;

  return (
    <section className={styles.notes}>
      <h2 className={styles.notesTitle}>{t('qps.notes.title')}</h2>
      <ul className={styles.notesList}>
        {notes.map((note) => (
          <li key={note.number} className={styles.note}>
            <sup className={styles.noteNumber}>{note.number}</sup>
            {note.content}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default QpsNotes;
